import React from "react";
import T from "prop-types";
import { StatusTag, StatusTags } from "MODULES/shared/components";
import { get } from "lodash";
import { CANCELLED, LINE_ITEMS, RECEIVED } from "APP_ROOT/constants";
import { APPROVED } from "MODULES/RepairOrders/constants";
import {
  CONSIGNED_DATE,
  CONSIGNMENT_TYPE,
  INVENTORY,
  MANAGED_REPAIR_IN_PROGRESS,
  MANAGED_REPAIR_REPAIRED
} from "MODULES/inventories/constants";
import { CONSIGNMENT } from "MODULES/Receiving/constants";

const Warnings = ({ repairOrder }) => {
  const empty = repairOrder.get(LINE_ITEMS).isEmpty();
  const finalized =
    !empty &&
    repairOrder.get(LINE_ITEMS).every(i => i.get("final_evaluation_approved"));

  const cancelled = repairOrder.get(CANCELLED);

  const customerRmaRequested =
    !empty &&
    repairOrder
      .get(LINE_ITEMS)
      .toJS()
      .some(
        l =>
          get(l, "inventory.most_recent_customer_rma") &&
          !get(l, "inventory.most_recent_customer_rma.cancelled") &&
          !get(l, "inventory.most_recent_customer_rma.credit_issued")
      );

  const mro =
    !empty &&
    repairOrder
      .get(LINE_ITEMS)
      .some(
        l =>
          l.getIn([INVENTORY, MANAGED_REPAIR_IN_PROGRESS]) ||
          l.getIn([INVENTORY, MANAGED_REPAIR_REPAIRED])
      );

  const consignment =
    !empty &&
    repairOrder
      .get(LINE_ITEMS)
      .some(
        l =>
          l.getIn([INVENTORY, CONSIGNED_DATE]) ||
          l.getIn([INVENTORY, CONSIGNMENT_TYPE]) === CONSIGNMENT
      );

  const vendorRmaRequestCancelled = repairOrder
    .get(LINE_ITEMS)
    .some(i => i.get("vendor_rma_status") === CANCELLED && !i.get(RECEIVED));

  const customerRmaRequestCancelled = repairOrder
    .get(LINE_ITEMS)
    .some(i => i.get("customer_rma_cancelled"));

  const exchangeGoneOutright = repairOrder
    .get(LINE_ITEMS)
    .some(i => i.get("exchange_gone_outright"));

  return (
    <StatusTags>
      {exchangeGoneOutright && (
        <StatusTag
          display="success"
          title="Exchange Gone Outright"
          icon="check"
        />
      )}
      {finalized && (
        <StatusTag display="success" title="Final Approval" icon="check" />
      )}
      {cancelled && <StatusTag display="danger" title="Cancelled" icon="ban" />}
      {customerRmaRequested && (
        <StatusTag display="danger" title="Customer RMA" icon="ban" />
      )}
      {vendorRmaRequestCancelled && (
        <StatusTag display="danger" title="Vendor RMA Cancelled" icon="ban" />
      )}
      {customerRmaRequestCancelled && (
        <StatusTag display="danger" title="Customer RMA Cancelled" icon="ban" />
      )}
      {!repairOrder.get(APPROVED) && (
        <StatusTag display="danger" title="Requires Approval" icon="pause" />
      )}
      {consignment && (
        <StatusTag
          display="warning"
          title="Consignment"
          icon="location-arrow"
        />
      )}
      {mro && (
        <StatusTag display="success" title="Managed Repair" icon="recycle" />
      )}
    </StatusTags>
  );
};

Warnings.propTypes = {
  repairOrder: T.instanceOf(Map)
};

export default Warnings;



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/Warnings.jsx